export default __webpack_public_path__ + "static/media/01.5226a59d.jpg";